// ExternalLink Icon:

// Core
import React from 'react'

const ExternalLink = () => (
  <svg width="12" viewBox="0 0 32 32">
    <path d="M32 0l-8 1 2.438 2.438-9.5 9.5-1.063 1.063 2.125 2.125 1.063-1.063 9.5-9.5 2.438 2.438 1-8zm-30 3c-1.088 0-2 .912-2 2v25c0 1.088.912 2 2 2h25c1.088 0 2-.912 2-2v-15h-3v14h-23v-23h15v-3h-16z" />
  </svg>
)

export default ExternalLink
